// @greenlight-spec: 11-observability.md#storage-and-tamper-evidence

/** "90 days", "1 year", "7 years", or "Keep indefinitely" for null. */
export function retentionLabel(days: number | null): string {
  if (days === null) return 'Keep indefinitely';
  if (days % 365 === 0) return days === 365 ? '1 year' : `${days / 365} years`;
  return `${days} days`;
}
